import { callBackendApi } from "src/components/service/axios";
import { Resources } from "../models/resources";

export const fetchAllResources = async (): Promise<Resources> => {
  return await callBackendApi("get", "/bff/resources");
};
